var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{ref:"shareIcon",staticClass:"mode-item",attrs:{"slot":"reference","data-clipboard-text":_vm.shareUrl,"size":20,"type":"share"},on:{"click":_vm.onSharePromptClick},slot:"reference"})
}
var staticRenderFns = []

export { render, staticRenderFns }